import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DateTimeDisplay } from 'ui-components/components/date-time-display/date-time-display';

import messages from '../messages';
import style from './store-status-dropdown.module.less';

const UpdatedStatus = ({ lastRefreshAttemptedDate = '' }) => {
  return (
    <div className={classnames(style['status-message'], style['status-success'])}>
      <FontAwesomeIcon className='active-icon' icon={faCircleCheck} />
      <span>
        <FormattedMessage {...messages.storeLastUpdated} />
      </span>
      &nbsp;
      <DateTimeDisplay utcTimestamp={lastRefreshAttemptedDate} />
    </div>
  );
};

UpdatedStatus.propTypes = {
  lastRefreshAttemptedDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
};

export default UpdatedStatus;
